import { useEffect, useState } from "react";
import { UI_CONFIG } from "../constants/index";

export default function Landing({ onContinue }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const renderHeader = () => (
    <div className={`flex items-center pb-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className={`${UI_CONFIG.LOGO_SIZE.MEDIUM}`}>
        <img 
          src="/static/juniorisep.svg" 
          alt="Logo" 
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );

  const renderContent = () => (
    <div className={`flex-1 flex flex-col justify-center max-w-lg mx-auto transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight text-left">
        Tournez & Gagnez
      </h1>
      
      <p className="text-base text-[12px] text-gray-600 mb-5 leading-relaxed text-left">
        Tente ta chance pour gagner un cadeau.
      </p>

      <button
        onClick={onContinue}
        className="w-full bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-semibold py-4 px-8 rounded-lg hover:from-orange-600 hover:to-yellow-600 transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl text-[13px] font-bold"
      >
        Tourner la roue
      </button>
    </div>
  );

  return (
    <div className="px-4 md:px-10 w-full h-screen bg-white flex flex-col overflow-hidden">
      <div className="flex-1 flex flex-col justify-center overflow-y-auto">
        {renderHeader()}
        {renderContent()}
      </div>
    </div>
  );
}
